import WalkthroughContent from './WalkthroughContent';

export default WalkthroughContent;